import { Box } from '@mui/material';
import * as React from 'react';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { RequireReduxData } from '~/components/RequireReduxData';
import { LeftSideMenu } from '~/features/Sidebars/LeftSideMenu';
import { allPortalDataDispatchReduxFetches } from '~/hooks/initializeData';
import { useVisible } from '~/hooks/useVisible';
import { LegacyEmployeeCard } from '~/legacy-components/LegacyEmployeeCard';
import { EmployeeActions } from '~/scenes/PeopleModule/components/EmployeeActions';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { SidebarLayout } from '~/scenes/PortalViews/components/SidebarLayout';
import { useEmployeeViews } from '~/scenes/PortalViews/Views/EmployeeViews/useEmployeeViews';

import { EmployeeModuleRouter } from './router';
import { useSxStyles } from './useStyles';

export const EmployeeViews = () => {
  const sxStyles = useSxStyles();

  const sidebar = useVisible(true);

  const {
    employeeId,
    isLoading,
    failedToLoadData,
    employeeCard: { profile, contracts, overlappingEmploymentHref },
    employeeActionsVisible,
    availableModules,
    hasFullAccess,
  } = useEmployeeViews();

  if (isLoading) {
    return <LoadingView />;
  }

  if (failedToLoadData || !profile) {
    return <>Failed to load view</>;
  }

  return (
    <SidebarLayout
      sidebar={
        <LeftSideMenu
          open={sidebar.isVisible}
          handleDrawerOpen={sidebar.show}
          handleDrawerClose={sidebar.hide}
          routerLink={true}
        />
      }
    >
      <Box sx={sxStyles.contentLayout}>
        <Box sx={sxStyles.top}>
          <LegacyEmployeeCard
            profile={profile}
            contracts={contracts}
            overlappingEmploymentHref={overlappingEmploymentHref}
          >
            TBA: Edit Links
          </LegacyEmployeeCard>
          {employeeActionsVisible && (
            <Box sx={sxStyles.actions}>
              <PortalErrorBoundary>
                <EmployeeActions employeeId={employeeId} />
              </PortalErrorBoundary>
            </Box>
          )}
        </Box>
        <RequireReduxData
          required={allPortalDataDispatchReduxFetches}
          renderLoading={(percentage) => (
            <LoadingView>{percentage}</LoadingView>
          )}
        >
          <PortalErrorBoundary>
            <EmployeeModuleRouter
              availableModules={availableModules}
              hasFullAccess={hasFullAccess}
            />
          </PortalErrorBoundary>
        </RequireReduxData>
      </Box>
    </SidebarLayout>
  );
};
